import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import { MainTabBasePathEnum } from '../../../enums/main-tabs';
import { StripePurchaseEnum } from '../../../enums/monetization';
import { ProfileSearchEnum } from '../../../enums/profile-search';
import * as fromMonetizationActions from '../../../store/actions/monetization.actions';
import { PaywallInformation } from '../../../store/models/monetization.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-paywall-modal',
  standalone: false,
  templateUrl: './paywall-modal.component.html'
})
export class PaywallModalComponent {
  private modalController = inject(ModalController);
  private store = inject(Store);

  paywallInformation$: Observable<PaywallInformation> = new Observable<PaywallInformation>();
  onboardingPaywall = false;

  redirectBackOnSuccess = false;

  defaultBackHref: string | undefined;

  close() {
    return this.modalController.dismiss(null, 'cancel');
  }

  async purchase(paywallInformation: PaywallInformation | null) {
    if (paywallInformation) {
      this.store.dispatch(
        fromMonetizationActions.paywallPurchase({
          data: {
            product: paywallInformation.product,
            purchaseType: paywallInformation.type,
            redirectBackOnSuccess: this.redirectBackOnSuccess,
            webPriceId: paywallInformation.webPriceId
          },
          searchType:
            this.defaultBackHref === MainTabBasePathEnum.PropertySearch
              ? ProfileSearchEnum.PropertySearchWalkingFarm
              : ProfileSearchEnum.WalkingFarm
        })
      );
    }
  }

  protected readonly stripePurchaseEnum = StripePurchaseEnum;
}
